import type { FC } from 'react';

import { Image } from '@/domains/core/Image/Image';

import { ListCardImageSvg } from './ListCardImageSVG';

import styles from './ListCardImage.module.scss';

interface Props {
  url?: string;
}

export const ListCardImage: FC<Props> = ({ url }) => {
  const containerStyles = url
    ? styles.itemImageContainer
    : styles.itemImageContainerColored;
  return (
    <div className={containerStyles}>
      {url ? (
        <Image
          className={styles.itemImageSrc}
          src={url}
          alt="LastProduct"
          height="56"
          width="56"
        />
      ) : (
        <ListCardImageSvg />
      )}
    </div>
  );
};
